import appConfigs from '@/app.config';
import { getCourse, getFunction } from '@/api/modules/user';
import { getRequirementType, getSourceSimple } from '@/api/modules/demand';
import { getPersonOnDuty } from "@/api/modules/home";

import {
  SET_LOADING_STATUS,
  SET_COLLAPSE_STATUS,
  SET_CURRENT_DATE,
  SET_BREADCRUMB_STATUS,
  SET_MULTIPLE_NAV_STATUS,
  SET_KEEPALIVE_STATUS,
  SET_LAYOUT,
  SET_NAVBAR_BACKGROUND,
  SET_SIDEBAR_BACKGROUND,
  SET_HEADER_STATUS,
  SET_SIDEBAR_STATUS,
  SET_DEVICE, SET_COLLAPSE_ACT,
} from '../actionTypes';

export type State = {
  loading: boolean,
  collapse: boolean,
  collapseAct: boolean,
  currentDate: number,
  device: string,
  [key: string]: any,
  courseOption: any,
  functionOption: any,
  typeOption: any,
  sourceOption: any,
  personOnDuty: any,
}

// state
const storeState: State = {
  loading: false,
  collapse: false,
  currentDate: new Date().getTime(),
  device: 'desktop',
  ...appConfigs,
  courseOption: [],
  functionOption: [],
  typeOption: [],
  sourceOption: [],
  personOnDuty: 'yangxin22',// 快速咨询
  collapseAct: false,
};
function getoptions(state: State) {
  getCourse().then((res: any) => {
    if (res.code === '200') {
      state.courseOption = res.data;
    }
  })
  getFunction().then((res: any) => {
    if (res.code === '200') {
      state.functionOption = res.data;
    }
  })
  getRequirementType().then((res: any) => {
    if (res.code === '200') {
      state.typeOption = res.data;
    }
  })
  getSourceSimple().then((res: any) => {
    if (res.code === '200') {
      state.sourceOption = res.data;
    }
  })
  getPersonOnDuty().then((res: any) => {
    if (res.code === '200' && res.data) {
      state.personOnDuty = res.data;
    }
  })
}
if (window.location.pathname !== '/approve/detail'){
  getoptions(storeState)
}

// mutations
const mutations = {
  [SET_LOADING_STATUS](state: State, param: boolean): void {
    state.loading = param;
  },
  [SET_DEVICE](state: State, param: string): void {
    state.device = param;
  },
  [SET_COLLAPSE_STATUS](state: State, param: boolean): void {
    state.collapse = param;
  },
  [SET_COLLAPSE_ACT](state: State, param: boolean): void {
    state.collapseAct = param;
  },
  [SET_CURRENT_DATE](state: State, param: number): void {
    state.currentDate = param;
  },

  [SET_BREADCRUMB_STATUS](state: State, param: boolean): void {
    state.useBreadcrumb = param;
  },
  [SET_MULTIPLE_NAV_STATUS](state: State, param: boolean): void {
    state.useMultipleNav = param;
  },
  [SET_KEEPALIVE_STATUS](state: State, param: boolean): void {
    state.useKeepAlive = param;
  },
  [SET_HEADER_STATUS](state: State, param: boolean): void {
    state.useHeader = param;
  },
  [SET_SIDEBAR_STATUS](state: State, param: boolean): void {
    state.useSidebar = param;
  },
  [SET_LAYOUT](state: State, param: string): void {
    state.layout = param;
  },
  [SET_NAVBAR_BACKGROUND](state: State, param: string): void {
    state.navbarBackground = param;
  },
  [SET_SIDEBAR_BACKGROUND](state: State, param: string): void {
    state.sidebarBackground = param;
  },
};

export default {
  namespaced: true,
  state: storeState,
  mutations,
};
